const pageTitle = {
    dashboard: 'Dashboard',
    catalogue: 'Telstra Connect shop',
    networks:'Data centre solutions',
    crossConnect:'Cross connect',
    editCrossConnect:'Edit cross connect',
    orderSummary: 'Order Summary',
    checkOut: 'Checkout',
    cart: 'Cart',
    savedCart: "Saved cart",
    manageSubscription: "Cross connect cable"
}

export { pageTitle};
